import styled from 'styled-components';

export const Container = styled.div``;

/**
 * Choose Type gets half the card. It is one short dropdown and a full-width
 * control for it would read as the most important field on the screen, which
 * it is not — the titles are.
 */
export const TypeField = styled.div`
  width: 50%;
  margin-bottom: var(--s4);

  @media (max-width: 1100px) {
    width: 100%;
  }
`;

/** The design's `.subhead` — a heading over a group inside a card body. */
export const SubHead = styled.div`
  margin: var(--s5) 0 var(--s3);
  font-size: var(--fs-th);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-faint);
`;

export const BooleanDefault = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s1);
  margin-top: var(--s4);
`;

/**
 * The design's `.help`.
 *
 * The control used to be labelled "Default Option", which says what the field
 * is called rather than what ticking it does. A yes/no customization is
 * either on or off when the order form opens, and this is that choice.
 */
export const Help = styled.p`
  margin: 0;
  font-size: var(--fs-micro);
  line-height: var(--lh-body);
  color: var(--text-faint);
`;

/** The design's `.actionbar`, on the card's foot. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  margin: var(--s5) calc(var(--s5) * -1) calc(var(--s5) * -1);
  padding: var(--s4) var(--s5);
  border-top: 1px solid var(--line);
  background: var(--surface-alt);
`;
